import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { DesignNotesToggle } from './designNotes'

// Shown at the top of every wireframe screen so reviewers never mistake
// the prototype for live functionality. Also hosts the design-notes toggle,
// which shows/hides the annotation layer across the whole screen.
export default function WireframeBanner() {
    return (
        <div className="flex items-center gap-2 px-6 py-2 bg-arwen-600 text-white text-xs font-medium">
            <InformationCircleIcon className="h-4 w-4 flex-none text-white" />
            <span>
                Proposed design — wireframe only. Not wired to live data; actions don't persist
                and no real profiles are affected.
            </span>
            <DesignNotesToggle />
        </div>
    )
}
